/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:56
 */
import Column from "./Column";

class TimestampColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default TimestampColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/TimestampColumn.js